export const PreTreatmentPhaseId = 0
export const TreatmentPhaseId = 1
export const PostTreatmentPhaseId = 2

export const debounceMilliseconds = 1000
export const minimumSearchCharacters = 1
